import request from "../util/request";

// 使用密码登录
export function loginByPwd(data) {
  return request({
    url: "grp/login",
    method: "post",
    data
  });
}
export function getTaskRounds() {
  return request({
    url: "grp/rounds",
    method: "get"
  });
}

/**
 * 查询任务列表
 * @param {*} params 
 * @returns 
 */
export function getTaskList(params) {
  return request({
    url: "grp/tasks",
    method: "get",
    params
  });
}

/**
 * 查询任务详情
 * @param {*} id 
 * @returns 
 */
export function getTaskDetail(id){
  return request({
    url: `grp/tasks/${id}`,
    method: 'GET'
  })
}

export function getEvaluationTree(params) {
  return request({
    url: "grp/evaluation_rules/_tree",
    method: "get",
    params
  });
}

export function getTaskPoints(params) {
  return request({
    url: "grp/points",
    method: "get",
    params
  });
}

export function getTaskPointsInfo(id) {
  return request({
    url: "grp/points/" + id,
    method: "get"
  });
}

/**
 * 申诉 Point 
 * @param {*} params 
 * @returns 
 */
export function appealPoint(id, data) {
  return request({
    url: `grp/points/${id}/_appeal`,
    method: "post",
    data
  });
}

/**
 * 查询项目详情
 * @param {*} id 
 * @returns 
 */
export function getProject(id){
  return request({
    url: `grp/projects/${id}`,
    method: 'GET'
  })
}

/**
 * 获取文件上传签名
 * @param {*} params 
 * @returns 
 */
export function signature(params) {
  return request({
    url: 'grp/files/alioss/signature',
    method: 'get',
    params
  })
}

export function getGroupTree(params) {
  return request({
    url: 'grp/groups/_tree',
    method: 'get',
    params
  })
}

export function actionPoint(id, data) {
  return request({
    url: `grp/points/${id}/actions`,
    method: 'post',
    data
  })
}

export function reviewTask(id, data) {
  return request({
    url: `grp/tasks/${id}/_review`,
    method: 'post',
    data
  })
}